@if (showAlert()) {
  <app-alert [type]="alertType()" [message]="alertMessage()" [autoClose]="true" [duration]="4000">
  </app-alert>
}

<div class="flex flex-col md:flex-row h-screen max-h-screen bg-[#f8fafc] overflow-hidden">
  <!-- Sidebar -->
  <div class="w-full md:w-[300px] h-[40vh] md:h-full bg-[#172C41] border-r border-[#1e3a52] flex flex-col overflow-hidden rounded-r-[8px]">
    <div class="flex justify-between items-center p-4 bg-[#172C41] text-[#e0e0e0] border-b border-white/10 shrink-0">
      <img class="h-10 w-auto block object-contain" src="assets/images/logo1.svg" alt="Logo">
      <button mat-icon-button (click)="ayuda()" matTooltip="Ayuda" class="text-white">
        <mat-icon>help</mat-icon>
      </button>
    </div>

    @if (isLoading()) {
      <div class="flex flex-col items-center justify-center p-10 text-[#90caf9]">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando monitores...</p>
      </div>
    }

    @if (error() && !isLoading()) {
      <mat-card class="m-4 bg-[#3d1f1f] border-l-4 border-[#f44336] text-[#ffbdbd]">
        <mat-card-content>
          <p>{{ error() }}</p>
          <button mat-raised-button color="warn" (click)="loadMonitors()">
            <mat-icon>refresh</mat-icon>
            Reintentar
          </button>
        </mat-card-content>
      </mat-card>
    }

    @if (!isLoading() && !error()) {
      <div class="flex-1 overflow-y-auto overflow-x-hidden bg-[#172C41]">
        <app-monitors-table [dataSource]="dataSource()" [isSitrackAdministrator]="isSitrackAdministrator()" [isAdministrator]="isAdministrator()" (monitorSelected)="onMonitorSelected($event)"
          (logoutClicked)="logout()" (openMonitorConfigClicked)="openMonitorConfig()"
          (openUsersConfigClicked)="openUsersConfig()">
        </app-monitors-table>
      </div>
    }
  </div>

  <!-- Alarmas -->
  <div class="flex-1 flex flex-col bg-white min-h-0 min-w-0 overflow-hidden">
    <div class="flex items-center justify-between mb-2.5 px-5 py-4 bg-gradient-to-br from-white to-[#f8f9fa] border-b-2 border-[#e8eaed] shadow-[0_2px_4px_rgba(0,0,0,0.04)] gap-4">
      <a routerLink="/spook" class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors text-sm hover:bg-[#172C41]"
        *appHasRole="['STK_ADMINISTRATION', 'STK_MEMBER', 'SPOOK_MEMBER', 'SPOOK_ADMINISTRATION']">Ir a Spook</a>
      <h2 class="text-[1.3rem] font-semibold m-0 text-[#172C41] tracking-[0.3px]"></h2>
      <h2 class="text-sm font-medium text-[#666] ml-auto">{{ userLoginName() ? '' + userLoginName() : '' }}</h2>
      <button mat-icon-button (click)="logout()" matTooltip="Salir" class="text-[#172C41]">
        <mat-icon>logout</mat-icon>
      </button>
    </div>

    <div class="flex-1 flex flex-col md:flex-row min-h-0 overflow-hidden">
      <div class="flex-1 flex flex-col min-h-0 overflow-hidden relative">
        @if (currentMonitorId()) {
          <div class="flex-1 flex flex-col min-h-0">
            <app-alarms-table class="flex-1 flex flex-col min-h-0" [monitores]="dataSource()"  [isSitrackAdministrator]="isSitrackAdministrator()" [monitorId]="selectedMonitorId()" (rowClicked)="onAlarmClicked($event)"
              (alarmsChange)="onAlarmsUpdate($event)" (closeAlarmDetails)="setShowAlarmDetails($event)"
              (closeUsersDetails)="showUsersDetails.set(false)" (closeMonitorDetails)="showMonitorDetails.set(false)"
              [isAdministrator]="isAdministrator()">
            </app-alarms-table>
          </div>
        }

        @if (!currentMonitorId() && dataSource().length) {
          <div class="flex-1 flex flex-col min-h-0">
            <app-dashboard [dataSource]="dataSource()" (showError)="showError($event)"
            (showSuccess)="showSuccess($event)"></app-dashboard>
          </div>
        }
      </div>

      @if (showAlarmDetails() && selectedAlarm()) {
        <div class="w-full md:w-[500px] shrink-0 border-t md:border-t-0 md:border-l border-[#ccc] bg-white">
          <app-alarms-details [monitorId]="selectedMonitorId()" [selectedAlarm]="selectedAlarm()" (closed)="showAlarmDetails.set(false)"
            [alarmsFromChild]="alarmsFromChild()">
          </app-alarms-details>
        </div>
      }

      @if (showMonitorDetails()) {
        <div class="w-full md:w-[500px] shrink-0 border-t md:border-t-0 md:border-l border-[#ccc] bg-white">
          <app-monitors-details (closed)="showMonitorDetails.set(false)" [monitorId]="selectedMonitorId()"
            (showError)="showError($event)" (showSuccess)="showSuccess($event)">
          </app-monitors-details>
        </div>
      }

      @if (showUsersDetails()) {
        <div class="w-full md:w-[500px] shrink-0 border-t md:border-t-0 md:border-l border-[#ccc] bg-white">
          <app-users-details (closed)="showUsersDetails.set(false)" (showError)="showError($event)"
            (showSuccess)="showSuccess($event)">
          </app-users-details>
        </div>
      }
    </div>
  </div>
</div>
